module.exports = __webpack_public_path__ + "img/blockchain-strengths-weaknesses.ef1b80bc.png";